import React from 'react';

const closeSidebar = () => {
  window.parent.postMessage({ action: 'close' }, '*');
}

const Header = ({ title }) => {
	return (
    <div>
      <header className="main">
        <span>
          {title || 'Blatout - Novidades e atualizações'}
        </span>
        <div className="close" onClick={()=>closeSidebar()}>
          <img src="./assets/icon-close.svg" alt="close icon" />
        </div>
      </header>
    </div>
  )
};

export default Header;